// ** Toolkit imports
import { configureStore } from "@reduxjs/toolkit";

// ** Reducers
import auth from "./apps/auth";
import user from "./apps/user";
import inspiration from "./apps/inspirationSlice";
import style from "./apps/styleSlice";
import tattoos from "./apps/tatoosSlice";
import template from "./apps/templateSlice";
import textToImage from "./apps/textToImageSlice";

export const store = configureStore({
  reducer: {
    auth,
    user,
    tattoos,
    inspiration,
    style,
    template,
    textToImage
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

